// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { ApplyGiftCodeData, ApplyGiftCodeResponses, CheckMissionData, CheckMissionResponses, ClaimAccumulatedSpunRewardData, ClaimAccumulatedSpunRewardResponses, ClaimPointRewardData, ClaimPointRewardResponses, ClaimServerSpunMilestoneData, ClaimServerSpunMilestoneResponses, CreateChampionPredictionData, CreateChampionPredictionResponses, CreateMatchPredictionData, CreateMatchPredictionResponses, CreateTopScorerPredictionData, CreateTopScorerPredictionResponses, GetConfigData, GetConfigResponses, GetCurrentGlobalSpunData, GetCurrentGlobalSpunResponses, GetGiftcodeStatusData, GetGiftcodeStatusResponses, GetLeaderboardData, GetLeaderboardResponses, GetMatchPredictionsData, GetMatchPredictionsResponses, GetParamData, GetParamResponses, GetPointRewardUserCountsData, GetPointRewardUserCountsResponses, GetReceivedMiniSpinCellsData, GetReceivedMiniSpinCellsResponses, GetRewardToFcoHistoryData, GetRewardToFcoHistoryResponses, GetStateData, GetStateResponses, GetUserLoginFakeData, GetUserLoginFakeResponses, GetUserMeData, GetUserMeResponses, MiniSpinData, MiniSpinResponses, SpinData, SpinResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Common params
 */
export const getParam = <ThrowOnError extends boolean = false>(options: Options<GetParamData, ThrowOnError>): RequestResult<GetParamResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetParamResponses, unknown, ThrowOnError>({ url: '/param', ...options });

export const getConfig = <ThrowOnError extends boolean = false>(options?: Options<GetConfigData, ThrowOnError>): RequestResult<GetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetConfigResponses, unknown, ThrowOnError>({ url: '/config', ...options });

export const getGiftcodeStatus = <ThrowOnError extends boolean = false>(options?: Options<GetGiftcodeStatusData, ThrowOnError>): RequestResult<GetGiftcodeStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetGiftcodeStatusResponses, unknown, ThrowOnError>({ url: '/giftcode/status', ...options });

export const applyGiftCode = <ThrowOnError extends boolean = false>(options: Options<ApplyGiftCodeData, ThrowOnError>): RequestResult<ApplyGiftCodeResponses, unknown, ThrowOnError> => (options.client ?? client).post<ApplyGiftCodeResponses, unknown, ThrowOnError>({
    url: '/giftcode/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getLeaderboard = <ThrowOnError extends boolean = false>(options?: Options<GetLeaderboardData, ThrowOnError>): RequestResult<GetLeaderboardResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLeaderboardResponses, unknown, ThrowOnError>({ url: '/leaderboard', ...options });

export const getUserLoginFake = <ThrowOnError extends boolean = false>(options?: Options<GetUserLoginFakeData, ThrowOnError>): RequestResult<GetUserLoginFakeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUserLoginFakeResponses, unknown, ThrowOnError>({ url: '/user/login/fake', ...options });

/**
 * Get user session
 */
export const getUserMe = <ThrowOnError extends boolean = false>(options?: Options<GetUserMeData, ThrowOnError>): RequestResult<GetUserMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUserMeResponses, unknown, ThrowOnError>({ url: '/user/me', ...options });

export const getState = <ThrowOnError extends boolean = false>(options?: Options<GetStateData, ThrowOnError>): RequestResult<GetStateResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetStateResponses, unknown, ThrowOnError>({ url: '/user/state', ...options });

export const checkMission = <ThrowOnError extends boolean = false>(options?: Options<CheckMissionData, ThrowOnError>): RequestResult<CheckMissionResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CheckMissionResponses, unknown, ThrowOnError>({ url: '/user/check-mission', ...options });

export const spin = <ThrowOnError extends boolean = false>(options?: Options<SpinData, ThrowOnError>): RequestResult<SpinResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SpinResponses, unknown, ThrowOnError>({
    url: '/user/spin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const miniSpin = <ThrowOnError extends boolean = false>(options?: Options<MiniSpinData, ThrowOnError>): RequestResult<MiniSpinResponses, unknown, ThrowOnError> => (options?.client ?? client).post<MiniSpinResponses, unknown, ThrowOnError>({ url: '/user/mini-spin', ...options });

export const getReceivedMiniSpinCells = <ThrowOnError extends boolean = false>(options?: Options<GetReceivedMiniSpinCellsData, ThrowOnError>): RequestResult<GetReceivedMiniSpinCellsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReceivedMiniSpinCellsResponses, unknown, ThrowOnError>({ url: '/user/mini-spin-cells', ...options });

export const claimAccumulatedSpunReward = <ThrowOnError extends boolean = false>(options?: Options<ClaimAccumulatedSpunRewardData, ThrowOnError>): RequestResult<ClaimAccumulatedSpunRewardResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ClaimAccumulatedSpunRewardResponses, unknown, ThrowOnError>({
    url: '/user/claim-accumulated-spun-reward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getRewardToFcoHistory = <ThrowOnError extends boolean = false>(options?: Options<GetRewardToFcoHistoryData, ThrowOnError>): RequestResult<GetRewardToFcoHistoryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRewardToFcoHistoryResponses, unknown, ThrowOnError>({ url: '/user/reward-to-fco-history', ...options });

export const createChampionPrediction = <ThrowOnError extends boolean = false>(options: Options<CreateChampionPredictionData, ThrowOnError>): RequestResult<CreateChampionPredictionResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateChampionPredictionResponses, unknown, ThrowOnError>({
    url: '/user/champion-predictions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createTopScorerPrediction = <ThrowOnError extends boolean = false>(options: Options<CreateTopScorerPredictionData, ThrowOnError>): RequestResult<CreateTopScorerPredictionResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTopScorerPredictionResponses, unknown, ThrowOnError>({
    url: '/user/top-scorer-predictions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getMatchPredictions = <ThrowOnError extends boolean = false>(options?: Options<GetMatchPredictionsData, ThrowOnError>): RequestResult<GetMatchPredictionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMatchPredictionsResponses, unknown, ThrowOnError>({ url: '/user/match-predictions', ...options });

export const createMatchPrediction = <ThrowOnError extends boolean = false>(options: Options<CreateMatchPredictionData, ThrowOnError>): RequestResult<CreateMatchPredictionResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateMatchPredictionResponses, unknown, ThrowOnError>({
    url: '/user/match-predictions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPointRewardUserCounts = <ThrowOnError extends boolean = false>(options?: Options<GetPointRewardUserCountsData, ThrowOnError>): RequestResult<GetPointRewardUserCountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPointRewardUserCountsResponses, unknown, ThrowOnError>({ url: '/point-reward/user-counts', ...options });

export const claimPointReward = <ThrowOnError extends boolean = false>(options: Options<ClaimPointRewardData, ThrowOnError>): RequestResult<ClaimPointRewardResponses, unknown, ThrowOnError> => (options.client ?? client).post<ClaimPointRewardResponses, unknown, ThrowOnError>({
    url: '/point-reward/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getCurrentGlobalSpun = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentGlobalSpunData, ThrowOnError>): RequestResult<GetCurrentGlobalSpunResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentGlobalSpunResponses, unknown, ThrowOnError>({ url: '/server-spun-milestone', ...options });

export const claimServerSpunMilestone = <ThrowOnError extends boolean = false>(options: Options<ClaimServerSpunMilestoneData, ThrowOnError>): RequestResult<ClaimServerSpunMilestoneResponses, unknown, ThrowOnError> => (options.client ?? client).post<ClaimServerSpunMilestoneResponses, unknown, ThrowOnError>({
    url: '/server-spun-milestone/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
